<template>
  <TosListVuetify entityName="colore-navi" :headers="headers" default-options="sortBy: 'updatedAt', sortDesc:'true'">
  

    <template #editF="slotProps">
      <div v-if="slotProps.data" class="p-cardialog-content">
        <v-row>
            <v-col cols="4">
              <v-text-field :label="tLabel('colore')+'*'" v-model="slotProps.data.colore" :rules="[rules.required]" :error-messages="slotProps.errors.colore"/>
            </v-col>
            <v-col cols="4">
              <div :style="{ 'background-color': slotProps.data.colore }">{{slotProps.data.colore}}</div>
            </v-col>
            
        </v-row>
      </div>
    </template>
    <template #item.colore1="slotProps"><div :style="{ 'background-color': slotProps.data.colore }">{{ slotProps.data.colore }}</div> </template>
  </TosListVuetify>
</template>

<script>
import TosListVuetify from "../../components/anagrafiche/TosListVuetify";
import FormatsMixins from "../../mixins/FormatsMixins";
import EnumMixin from "../../mixins/yard/EnumMixin";

export default {
  name: "ColoriNavi",
  data() {
    return {
      headers: [
        { text: "", value: "action" },
        { text: "Colore", value: "colore" },
        { text: "Colore", value: "colore1" },
        { text: "Call Id", value: "callId" },
        { text: "Carrier Out Voyage", value: "carrierOutVoy" },
        { text: "Last Updated At", value: "updatedAt",formatValue: "formatDateTimeFromDate" }
      ]
    };
  },
  components: {
    TosListVuetify: TosListVuetify
  },
  mixins: [FormatsMixins, EnumMixin],
  methods: {
    validate(item) {
       let errors = {};
       // TODO
       return errors;
    }
  },
};
</script>
